import { ENV } from "@/config/env";
import { useEffect } from "react";

export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...parameters,
  });
};

const Analytics = () => {
  const measurementId = ENV.GA_MEASUREMENT_ID || ENV.GOOGLE_ANALYTICS_ID;

  useEffect(() => {
    if (!measurementId || typeof document === "undefined") return;

    const existingScript = document.getElementById("gtag-js");
    if (existingScript) return;

    const script = document.createElement("script");
    script.id = "gtag-js";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", measurementId, {
      send_page_view: false,
      anonymize_ip: true,
    });
  }, [measurementId]);

  return null;
};

export default Analytics;
